import { render } from "./CarUpload.vue?vue&type=template&id=bb9c07ac&scoped=true"
import script from "./CarUpload.vue?vue&type=script&lang=js"
export * from "./CarUpload.vue?vue&type=script&lang=js"

import "./CarUpload.vue?vue&type=style&index=0&id=bb9c07ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9c07ac"]])

export default __exports__